import { FormControlLabel, Radio, RadioGroup } from "@mui/material"
import FlexRow from "~components/FlexRow"
import FlexCol from "~components/FlexCol"
import Input from "~app/Input"
import { ERROR_MESSAGES } from "~constants/errorMessages"
import ImageUpload from "~components/imageUpload/ImageUpload"
import FileUpload from "~components/FileUpload"
import { useEffect } from "react"
import { OPTIONS } from "~components/proofOfOwnership/UploadProofOfOwnershipModal"

const UploadForm = ({
  selectedOption,
  setSelectedOption,
  register,
  setValue,
  getValues,
  unregister,
  errors,
  broker,
  userName,
}) => {
  useEffect(() => {
    if (!!userName) {
      setValue("name", userName)
    }

    if (!!broker) {
      setValue("broker", broker)
    }
  }, [])

  return (
    <>
      <RadioGroup
        name="file_type"
        onChange={(_e, v) => setSelectedOption(v)}
        value={selectedOption}
        style={{
          justifyContent: "center",
          marginBottom: 20,
          flex: 1,
          flexDirection: "row",
        }}
      >
        <FormControlLabel
          value={OPTIONS.IMAGE}
          control={<Radio />}
          label="Upload image(s)"
        />
        <FormControlLabel
          value={OPTIONS.PDF}
          control={<Radio />}
          label="Upload PDF file"
        />
      </RadioGroup>

      <FlexRow>
        <FlexCol>
          <Input
            name="broker"
            placeholder="Broker"
            label=""
            disabled={false}
            register={register("broker", { required: true })}
            errorMessage={errors.broker && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </FlexCol>
      </FlexRow>

      <FlexRow>
        <FlexCol>
          <Input
            name="name"
            placeholder="Name"
            label=""
            disabled={false}
            register={register("name", { required: true })}
            errorMessage={errors.name && ERROR_MESSAGES.FIELD_REQUIRED}
          />
        </FlexCol>
      </FlexRow>
      {selectedOption === OPTIONS.IMAGE ? (
        <ImageUpload
          key="image"
          name="image"
          label="Import image(s)"
          required={selectedOption === OPTIONS.IMAGE}
          maxNumber={4}
          multiple={true}
          className="multiple"
          acceptTypes={["jpg", "png", "jpeg"]}
          maxFileSize={5}
          text="Drag a JPG, JPEG or PNG format or upload via the Import button"
          {...{ register, setValue, getValues, unregister }}
        />
      ) : (
        <>
          <FileUpload
            name="file"
            accept=".pdf"
            disabled={false}
            required={true}
            register={register}
            setValue={setValue}
            unregister={unregister}
            text="Drag a PDF file here or upload via the Import file button"
          />
        </>
      )}
    </>
  )
}
export default UploadForm
